// viewport.js — small breakpoint helpers for device-aware routing.
//
// The merchant flow has three surfaces (phone Console, full dashboard
// for iPad/desktop). Pages and the UserMenu mode switcher branch on
// these breakpoints to send users to the right home for their device.
//
// Mirrors the design-system breakpoint of 768px (everything ≥ 768 gets
// the full experience). 768 is the iPad mini portrait width and a
// natural cutoff between mobile-first card stacks and desktop-feeling
// grid layouts.

import { useEffect, useState } from 'react'

export const PHONE_BREAKPOINT = 768

export function isPhoneViewport() {
  if (typeof window === 'undefined') return false
  return window.innerWidth < PHONE_BREAKPOINT
}

/**
 * React hook that re-renders when the viewport crosses the phone
 * breakpoint. Used by the UserMenu mode switcher to pick the right
 * landing route for the user's current device.
 */
export function useIsPhone() {
  const [isPhone, setIsPhone] = useState(isPhoneViewport)
  useEffect(() => {
    const onResize = () => setIsPhone(isPhoneViewport())
    window.addEventListener('resize', onResize)
    // Also catch orientation changes on real devices.
    window.addEventListener('orientationchange', onResize)
    return () => {
      window.removeEventListener('resize', onResize)
      window.removeEventListener('orientationchange', onResize)
    }
  }, [])
  return isPhone
}
